export const helper = {
  noUserSelect: `
    -webkit-touch-callout: none;
    user-select: none;
  `
};